import React from 'react';
import { Typography } from '@one-thd/sui-atomic-components';
import { AssistantIcon } from '../../assets/AssistantIcon';

const TITLE = 'Need help?';
const SUBTITLE = 'Get an answer now with AI';

export const BannerHeader = () => {
  return (
    <div
      id="ai-assisted-search-banner-header"
      data-testid="ai-assisted-search-banner-header"
      className="sui-flex sui-items-center sui-gap-4"
    >
      <AssistantIcon color="brand" height={52} width={45} />
      <div className="sui-flex sui-flex-col">
        <Typography
          id="ai-assisted-search-banner-title"
          component="h2"
          variant="h3"
          weight="bold"
          color="primary"
        >
          {TITLE}
        </Typography>
        <Typography variant="body-base" color="medium" height="tight">
          {SUBTITLE}
        </Typography>
      </div>
    </div>
  );
};

BannerHeader.displayName = 'BannerHeader';
